import { contributeAiCapabilityParamOption } from "@medflyt/webapp-react/src/modules/ai-omnibar/ai-capability-registry";

export function sideNavigationItem() {
    return {
        restrict: 'E',
        templateUrl: 'admin/views/side-navigation-item.html',
        scope: {
            title: '<',
            labelText: '<',
            stateName: '<',
            sectionName: '<',
            iconPath: '<',
            permissionKey: '<',
            materialIcon: '<',
            subItems: '='
        },
        /* @ngInject */
        controller: function ($scope, $rootScope, $state) {
            $scope.onMouseEnter = function () {
                $rootScope.sidenavHover($scope.sectionName);
            };

            $scope.onChevClick = function () {
                event.stopPropagation();
                $rootScope.sidenavFocus($scope.sectionName);
            };

            $scope.onMainItemClick = function () {
                event.stopPropagation();
                $rootScope.sidenavFocus($scope.sectionName);
                if (!$scope.subItems.length) {
                    $state.go($scope.stateName);
                } else {
                    $state.go($scope.subItems[0].stateName);
                }
            };

            $scope.onSubItemClick = function (stateName) {
                if (stateName) {
                    $state.go(stateName, {}, { reload: true });
                }
            };

            // Every navigation item hands its own destination to the AI omnibar's navigate
            // capability, using the same permission rule as the view-permission directive that
            // hides it. Nothing anywhere else knows the list of pages.
            const releaseAiOptions = [];

            function isPermittedToSee(permissionKey) {
                if (permissionKey === undefined || permissionKey === null || permissionKey === "") {
                    return true;
                }

                try {
                    return String(permissionKey)
                        .split("|")
                        .some((key) => $rootScope.isPermittedByKey(key));
                } catch (error) {
                    return false;
                }
            }

            function contributeAiNavigationOptions() {
                if (!$scope.title || !isPermittedToSee($scope.permissionKey)) {
                    return;
                }

                const subItems = $scope.subItems ?? [];

                if (subItems.length === 0) {
                    if ($scope.stateName) {
                        contribute($scope.stateName, $scope.title);
                    }

                    return;
                }

                subItems.forEach((subItem) => {
                    if (!subItem.stateName || !isPermittedToSee(subItem.permissionKey)) {
                        return;
                    }

                    contribute(subItem.stateName, $scope.title + " > " + subItem.text);
                });
            }

            function contribute(stateName, label) {
                releaseAiOptions.push(
                    contributeAiCapabilityParamOption("app.navigate", "destination", {
                        value: stateName,
                        label,
                    })
                );
            }


            function releaseAiNavigationOptions() {
                releaseAiOptions.forEach((release) => release());
                releaseAiOptions.length = 0;
            }

            // Sections gain items after the sidebar has rendered - Patients gains Intake once the
            // agency is known, and each of those pushes goes to the array this directive was given.
            // Contributing once at link time would offer the AI a shorter list of pages than the
            // person is looking at.
            $scope.$watchCollection("subItems", () => {
                releaseAiNavigationOptions();
                contributeAiNavigationOptions();
            });

            contributeAiNavigationOptions();

            $scope.$on("$destroy", releaseAiNavigationOptions);

            if ($scope.labelText === "unread_count") {
                $scope.$watch(
                    function () {
                        return $rootScope.mentionesCount;
                    },
                    function () {
                        $scope.labelText = $rootScope.mentionesCount;
                    },
                    true
                );
            }
        }
    };
}
;
